import * as React from "react";
const ClinicIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M36 9H12.667A1.672 1.672 0 0 0 11 10.667V29h26.667V10.667A1.672 1.672 0 0 0 36 9Zm-6.667 12.5h-2.5V24a2.5 2.5 0 0 1-5 0v-2.5h-2.5a2.5 2.5 0 0 1 0-5h2.5V14a2.5 2.5 0 0 1 5 0v2.5h2.5a2.5 2.5 0 0 1 0 5ZM16 7.333h16.667a1.667 1.667 0 0 0 0-3.333H16a1.667 1.667 0 1 0 0 3.333ZM11 44h10v-8.333A1.672 1.672 0 0 1 22.667 34H26c.92.003 1.664.747 1.667 1.667V44h10V30.667H11V44Z",
  clipRule: "evenodd"
}));
export default ClinicIcon;